module.exports = __webpack_public_path__ + "img/t5-c3.90e14a80.png";